import CategoryRemoveButton from "../CategoryRemoveButton";
import CategoryRestoreButton from "../CategoryRestoreButton";
import CategoryUpdateButton from "../CategoryUpdateButton";
import styles from "./styles.module.css"

export default function CategoryItem({ categoryData, count, collectionRef, updateTableData }) {
    return (
        <div className={styles.optionsButtons}>
            <CategoryUpdateButton updateTableData={updateTableData} collectionRef={collectionRef} categoryData={categoryData} />
            {
                categoryData.active
                    ?
                    <CategoryRemoveButton updateTableData={updateTableData} categoryId={categoryData.id} />
                    :
                    <CategoryRestoreButton updateTableData={updateTableData} categoryId={categoryData.id} />
            }
        </div>

    );
}